import { useMutation } from 'react-query'
import {
  forgotPassword,
  loginUser,
  logoutUser,
  refreshAuth,
  registerUser,
  resetPassword,
  setPassword
} from '../api-services/auth'

const useRegister = mutationOptions => {
  const mutation = useMutation({
    mutationFn: payload => registerUser(payload),
    onSuccess: data => {
      if (mutationOptions.onSuccess) {
        mutationOptions.onSuccess(data)
      }
    },
    onError: error => {
      if (mutationOptions.onError) {
        mutationOptions.onError(error)
      }
    }
  })

  return {
    register: mutation.mutate,
    isLoading: mutation.isPending,
    ...mutation
  }
}

const useLogin = mutationOptions => {
  const mutation = useMutation({
    mutationFn: payload => loginUser(payload),
    onSuccess: data => {
      if (mutationOptions.onSuccess) {
        mutationOptions.onSuccess(data)
      }
    },
    onError: error => {
      if (mutationOptions.onError) {
        mutationOptions.onError(error)
      }
    }
  })

  return {
    login: mutation.mutate,
    isLoading: mutation.isLoading,
    ...mutation
  }
}

const useForgotPassword = mutationOptions => {
  const mutation = useMutation({
    mutationFn: payload => forgotPassword(payload),
    onSuccess: data => {
      if (mutationOptions.onSuccess) {
        mutationOptions.onSuccess(data)
      }
    },
    onError: error => {
      if (mutationOptions.onError) {
        mutationOptions.onError(error)
      }
    }
  })

  return {
    forgotPassword: mutation.mutate,
    isLoading: mutation.isLoading,
    ...mutation
  }
}

const useResetPassword = mutationOptions => {
  const mutation = useMutation({
    mutationFn: payload => resetPassword(payload),
    onSuccess: data => {
      if (mutationOptions.onSuccess) {
        mutationOptions.onSuccess(data)
      }
    },
    onError: error => {
      if (mutationOptions.onError) {
        mutationOptions.onError(error)
      }
    }
  })

  return {
    resetPassword: mutation.mutate,
    isLoading: mutation.isLoading,
    ...mutation
  }
}

const useSetPassword = mutationOptions => {
  const mutation = useMutation({
    mutationFn: payload => setPassword(payload),
    onSuccess: data => {
      if (mutationOptions.onSuccess) {
        mutationOptions.onSuccess(data)
      }
    },
    onError: error => {
      if (mutationOptions.onError) {
        mutationOptions.onError(error)
      }
    }
  })

  return {
    setPassword: mutation.mutate,
    isLoading: mutation.isLoading,
    ...mutation
  }
}

const useRefreshAuth = mutationOptions => {
  const mutation = useMutation({
    mutationFn: payload => refreshAuth(payload),
    onSuccess: data => {
      if (mutationOptions.onSuccess) {
        mutationOptions.onSuccess(data)
      }
    },
    onError: error => {
      if (mutationOptions.onError) {
        mutationOptions.onError(error)
      }
    }
  })

  return {
    refreshAuth: mutation.mutate,
    isLoading: mutation.isLoading,
    ...mutation
  }
}

const useLogoutUser = mutationOptions => {
  const mutation = useMutation({
    mutationFn: () => logoutUser(),
    onSuccess: data => {
      if (mutationOptions.onSuccess) {
        mutationOptions.onSuccess(data)
      }
    },
    onError: error => {
      if (mutationOptions.onError) {
        mutationOptions.onError(error)
      }
    }
  })

  return {
    logout: mutation.mutate,
    isLoading: mutation.isLoading,
    ...mutation
  }
}

export {
  useRegister,
  useLogin,
  useForgotPassword,
  useResetPassword,
  useSetPassword,
  useRefreshAuth,
  useLogoutUser,
}
